import { render, staticRenderFns } from "./AR.md?vue&type=template&id=18ae48b2&"
import script from "./AR.md?vue&type=script&lang=js&"
export * from "./AR.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports